.root {
  min-height: 100%;
  background: var(--ant-color-bg-layout);
  color: var(--ant-color-text);
  font-family: var(--ant-font-family);
}
